import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { Image } from "primereact/image";
import { Divider } from "primereact/divider";
import {
  getSetupDetails,
  updateHeroSection,
  getBannerImages,
  uploadBannerImage,
  deleteBannerImage,
} from "../../../store/AsyncMethods/SetupMethod";
import { toast } from "react-toastify";
import { SelectButton } from "primereact/selectbutton";
import OrderNumberSettings from "../OrderNumberSettings";

export default function ManageHeroSection() {
  const dispatch = useDispatch();
  const [heroImageUrl, setHeroImageUrl] = useState(null);
  const [heroImage, setHeroImage] = useState(null);
  const heroUploadRef = useRef(null);

  const navigate = useNavigate();
  const { setupDetails, bannerImages } = useSelector((state) => state.SetupReducer);

  const onHeroImageUpload = () => {
    if (heroUploadRef.current) {
      const inputElement = heroUploadRef.current.getInput();
      inputElement?.click();
    }
  };

  const onHeroImageDelete = (id) => {
    dispatch(deleteBannerImage(id)).then((success) => {
      if (success) {
        dispatch(getBannerImages());
      }
    });
  };

  const onHeroImageSelect = (e) => {
    const file = e.files[0];

    if (!file) {
      toast.error("File is invalid or exceeding size");
      return;
    }
    const formData = new FormData();
    formData.append("banner", file);
    dispatch(uploadBannerImage(formData)).then((success) => {
      if (success) {
        dispatch(getBannerImages());
      }
    });
    //setHeroImageUrl(file);

   // const url = URL.createObjectURL(file);
   // setHeroImage(url);
  };

  const statusOptions = [
    { name: "Enabled", value: 1 },
    { name: "Disabled", value: 0 },
  ];

  useEffect(() => {
    if (setupDetails) {
      formik.setValues({
        heroHeading1: setupDetails?.hero_h1 || "",
        heroHeading2: setupDetails?.hero_h2 || "",
        heroPlaceHolder: setupDetails?.hero_placeHolder || "",
        heroHeading1Enable: setupDetails?.hero_h1_enabled ?? 1,
        heroHeading2Enable: setupDetails?.hero_h2_enabled ?? 1,
        heroPlaceHolderEnable: setupDetails?.hero_placeHolder_enabled ?? 1,
      });
    }
  }, [setupDetails]);

  const formik = useFormik({
    initialValues: {
      heroHeading1: "",
      heroHeading2: "",
      heroPlaceHolder: "",
      heroHeading1Enable: 1,
      heroHeading2Enable: 1,
      heroPlaceHolderEnable: 1,
    },
    validationSchema: Yup.object({
      heroHeading1: Yup.string().required("Hero Heading 1 Required"),
      heroHeading2: Yup.string().required("Hero Heading 1 Required"),
      heroPlaceHolder: Yup.string().required("Hero Placeholder Required"),
    }),

    onSubmit: async (data) => {
    

      dispatch(updateHeroSection(data)).then((success) => {
        if (success) {
          formik.resetForm();
          dispatch(getSetupDetails());
          navigate("/site-setup/hero-section");
        }
      });
    },
  });

  useEffect(() => {
    dispatch(getSetupDetails());
    dispatch(getBannerImages());
  }, []);

  return (
    <div className="mx-4">
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow-md rounded-lg p-4 mt-3">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-black mx-1">
              Customize Hero Section
            </span>
          </Divider>
          <Button
            onClick={() => {
              navigate("/site-setup");
            }}
            type="button"
            label="Back"
            icon="pi pi-arrow-left"
            className="  p-primary-highlight-btn mb-3"
          />

          <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="heroHeading1" className="">
                  Heading 1
                </label>
                <span className="flex  w-full gap-2 justify-center items-center">
                  <InputText
                    id="heroHeading1"
                    name="heroHeading1"
                    maxLength={255}
                    className="w-full text-lg p-primary-input"
                    value={formik.values.heroHeading1}
                    onChange={formik.handleChange}
                  />

                  <SelectButton
                    name="heroHeading1Enable"
                    id="heroHeading1Enable"
                    options={statusOptions}
                    optionLabel="name"
                    optionValue="value"
                    className="flex"
                    pt={{
                      root: { className: "flex" },
                      button: ({ context }) => ({
                        className: context.selected
                          ? "p-primary-highlight-btn w-full text-lg text-center"
                          : "w-full text-lg text-center",
                      }),
                    }}
                    value={formik.values.heroHeading1Enable}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.heroHeading1 && formik.errors?.heroHeading1 && (
                <div className="p-error">{formik.errors?.heroHeading1}</div>
              )}
            </div>

            <div className="">
              <div className=" flex flex-col gap-2">
                <label htmlFor="heroHeading2" className="">
                  Heading 2
                </label>
                <span className="flex  w-full gap-2 items-center justify-center">
                  <InputText
                    id="heroHeading2"
                    name="heroHeading2"
                    maxLength={255}
                    className="w-full text-lg p-primary-input"
                    value={formik.values.heroHeading2}
                    onChange={formik.handleChange}
                  />
                  <SelectButton
                    name="heroHeading2Enable"
                    id="heroHeading2Enable"
                    options={statusOptions}
                    optionLabel="name"
                    optionValue="value"
                    className="flex"
                    pt={{
                      root: { className: "flex" },
                      button: ({ context }) => ({
                        className: context.selected
                          ? "p-primary-highlight-btn w-full text-lg text-center"
                          : "w-full text-lg text-center",
                      }),
                    }}
                    value={formik.values.heroHeading2Enable}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
            </div>

            <div className="">
              <div className=" flex flex-col gap-2">
                <label htmlFor="heroPlaceHolder" className="">
                  Search PlaceHolder
                </label>
                <span className="flex  w-full gap-2 items-center justify-center">
                  <InputText
                    id="heroPlaceHolder"
                    name="heroPlaceHolder"
                    maxLength={255}
                    className="w-full text-lg p-primary-input"
                    value={formik.values.heroPlaceHolder}
                    onChange={formik.handleChange}
                  />
                  <SelectButton
                    name="heroPlaceHolderEnable"
                    id="heroPlaceHolderEnable"
                    options={statusOptions}
                    optionLabel="name"
                    optionValue="value"
                    className="flex"
                    pt={{
                      root: { className: "flex" },
                      button: ({ context }) => ({
                        className: context.selected
                          ? "p-primary-highlight-btn w-full text-lg text-center"
                          : "w-full text-lg text-center",
                      }),
                    }}
                    value={formik.values.heroPlaceHolderEnable}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.heroPlaceHolder &&
                formik.errors?.heroPlaceHolder && (
                  <div className="p-error">
                    {formik.errors?.heroPlaceHolder}
                  </div>
                )}
            </div>
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="heroImage" className="">
                  Hero Image
                </label>
                <div className=" flex flex-col gap-2">
                  <Button
                    onClick={onHeroImageUpload}
                    type="button"
                    label="Upload"
                    icon="pi pi-plus"
                    className="  p-primary-highlight-btn"
                  />

                  <FileUpload
                    ref={heroUploadRef}
                    mode="basic"
                    name="hero-image-upload"
                    accept="image/*"
                    maxFileSize={5000000}
                    auto
                    onSelect={onHeroImageSelect}
                    style={{ display: "none" }}
                  />
                  <small id="hero--image-upload-help">
                    Please upload a supported image file smaller than 5MB.1920px × 1080px 16:9 aspect ratio
                  </small>

                  <div className="flex flex-row-reverse">
                    <div className=" w-[128px] h-[128px] overflow-y-scroll">
                    {bannerImages?.map((image) => (
                      <div className="flex flex-row gap-2">
                      <Image
                        src={image.image_path}
                        alt="Uploaded Hero Image"
                        width="128"
                        height="128"
                        preview
                      />
                      <span className="text-red-500 cursor-pointer" onClick={() => onHeroImageDelete(image.id)}>
                        <i className="pi pi-trash"></i>
                      </span>
                      </div>
                    ))}
                    </div>
                  </div>
                </div>
              </div>
              {formik.touched?.heroImage && formik.errors?.heroImage && (
                <div className="p-error">{formik.errors?.heroImage}</div>
              )}
            </div>
          </div>
        </div>

        <div className="mt-8">
          <div className="flex justify-end gap-4">
            <Button
              label="Clear"
              icon="pi pi-times"
              className="p-red-btn"
              type="button"
              onClick={() => {
                formik.resetForm();
              }}
            />
            <Button
              type="submit"
              label="Save"
              icon="pi pi-check"
              className="p-secondary-btn"
            />
          </div>
        </div>
      </form>

      {/* Order Number Settings */}
      <div className="mt-8">
        <OrderNumberSettings />
      </div>
    </div>
  );
}
